import { render, staticRenderFns } from "./viewTpl.vue?vue&type=template&id=6f0e81ce&scoped=true&"
import script from "./viewTpl.vue?vue&type=script&lang=js&"
export * from "./viewTpl.vue?vue&type=script&lang=js&"
import style0 from "./viewTpl.vue?vue&type=style&index=0&id=6f0e81ce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0e81ce",
  null
  
)

export default component.exports